import {Component, Input, OnInit} from "@angular/core";
import {environment} from "../../../../environments/environment";

@Component({
    selector: 'app-framework',
    templateUrl: './framework.component.html',
})
export class FrameworkComponent implements OnInit{
    env = environment;

    @Input('framework') framework: number;
    constructor(){}

    ngOnInit(){}


}


// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/projects/shared/framework/framework.component.ts